export class ParametroConsultaDetalle {

  constructor(){
    this.EntidadSolicitud = "";
    this.Solicitud = 0;
  }

    EntidadSolicitud: string;
    Solicitud: number;

  }
  
  export default ParametroConsultaDetalle;